import type {BrickCalculation} from '@refra/modules/refra-planning/types'

export const getBrickShapesWithSymbol = (
  brickCalculation?: BrickCalculation
): {name: string; symbol: 'X' | 'o'; numberOfBricksPerRing?: number}[] => {
  if (!brickCalculation) return []

  const {layingPattern} = brickCalculation
  if (layingPattern.length === 0) return []

  return Array.from(new Set<string>(layingPattern as string[])).map((name, index) => ({
    name,
    symbol: index === 0 ? 'X' : 'o',
    numberOfBricksPerRing:
      brickCalculation.shapes.find((shape) => shape.name === name)?.numberOfBricksPerRing ?? 0
  }))
}

export const getBrickFormat = (brickCalculation?: BrickCalculation) => {
  const [firstShape, secondShape] = getBrickShapesWithSymbol(brickCalculation)

  if (!firstShape && !secondShape) return ''

  if (firstShape && secondShape) {
    return `${firstShape.name}/${secondShape.name}${firstShape.numberOfBricksPerRing}/${secondShape.numberOfBricksPerRing} St.`
  }

  const shape = firstShape ?? secondShape
  return `${shape.name}${shape.numberOfBricksPerRing} St.`
}

export const getBrickPattern = (brickCalculation?: BrickCalculation) => {
  const brickShapeSymbols = getBrickShapesWithSymbol(brickCalculation)
  if (!brickShapeSymbols.length) return ''

  const layingPattern = brickCalculation ? brickCalculation.layingPattern : []
  const pattern = layingPattern
    .map((shapeName) => brickShapeSymbols.find((item) => item.name === shapeName)?.symbol)
    .join('')

  return pattern || ''
}
